/** Buenos días hasta las 13:59; Buenas tardes desde las 14:00. */
export function saludoPorHorario(fecha = new Date()) {
  return fecha.getHours() < 14 ? "Buenos días" : "Buenas tardes";
}

/** Nombre legible para textos (sin extensión ni referencia de expediente). */
export function nombreDocumentoLegible(nombreArchivo) {
  let s = String(nombreArchivo || "").trim();
  if (!s) return "";
  s = s.replace(/\.(docx|pdf|doc)$/i, "");
  s = s.replace(/\s+PR\d{1,4}[-/]\d{1,4}$/i, "");
  return s.trim() || String(nombreArchivo || "").trim();
}

function listadoDocumentos(archivos) {
  const list = (archivos || []).map((a) => nombreDocumentoLegible(a)).filter(Boolean);
  if (!list.length) return "la documentación adjunta";
  if (list.length === 1) return list[0];
  return `${list.slice(0, -1).join(", ")} y ${list[list.length - 1]}`;
}

function fraseDevolverFirmado(archivos) {
  const n = (archivos || []).map((a) => String(a || "").trim()).filter(Boolean).length;
  if (n <= 1) return "lo devuelvas firmado";
  return "los devuelvas firmados";
}

/** Inferencia por nombre propio cuando no hay sexo en perfil (español). */
export function inferirSexoDesdeNombre(nombre) {
  const primero = String(nombre || "").trim().split(/\s+/)[0]?.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "") || "";
  if (!primero) return null;
  const femeninos = new Set([
    "maria", "ana", "laura", "rocio", "antonia", "maribel", "carmen", "elena", "paula",
    "lucia", "marta", "sara", "clara", "isabel", "teresa", "josefa", "cristina", "patricia",
    "beatriz", "silvia", "monica", "lourdes", "nuria", "alicia", "raquel", "sonia",
  ]);
  const masculinos = new Set([
    "juan", "angel", "marco", "carlos", "pedro", "jose", "david", "pablo", "miguel",
    "antonio", "francisco", "manuel", "sergio", "alberto", "fernando", "javier", "luis",
    "rafael", "vicente", "jorge", "daniel", "alejandro", "ruben", "oscar",
  ]);
  if (femeninos.has(primero)) return "Mujer";
  if (masculinos.has(primero)) return "Hombre";
  if (primero.endsWith("a") && !["garcia", "joshua", "nicola", "luca"].includes(primero)) return "Mujer";
  return null;
}

/** "encantada" / "encantado" según sexo del emisor (perfil o inferido por nombre). */
export function encantadoDeSaludar(sexo, nombre) {
  const s = String(sexo || "").toLowerCase().trim();
  if (s.startsWith("muj") || s === "f" || s === "femenino") return "encantada";
  if (s.startsWith("hom") || s === "m" || s === "masculino") return "encantado";
  const inf = inferirSexoDesdeNombre(nombre);
  if (inf === "Mujer") return "encantada";
  if (inf === "Hombre") return "encantado";
  return "encantado";
}

/**
 * Respuestas rápidas exclusivas de Gestión Ventas (WhatsApp / Email).
 * @param {{ nombreUsuario?: string, sexo?: string, poblacion?: string, direccion?: string, archivos?: string[] }} ctx
 */
export function buildGestionVentasQuickReplies({ nombreUsuario, sexo, poblacion, direccion, archivos = [] } = {}) {
  const saludo = saludoPorHorario();
  const user = String(nombreUsuario || "").trim() || "—";
  const enc = encantadoDeSaludar(sexo, user);
  const pob = String(poblacion || "").trim() || "—";
  const dir = String(direccion || "").trim() || "—";
  const docs = listadoDocumentos(archivos);
  const devolver = fraseDevolverFirmado(archivos);

  const base = `${saludo},\nsoy ${user} del departamento de administración de Vitalcasa, ${enc} de saludarte. Te envío este mensaje para notificar la venta de su vivienda sita en ${pob}, ${dir}.\nEnhorabuena por la venta`;

  return [
    {
      id: "gv-comunicar-venta",
      emoji: "🏠",
      label: "Comunicar Venta",
      text: base,
    },
    {
      id: "gv-comunicar-venta-aut",
      emoji: "📎",
      label: "Comunicar venta+Autorización",
      text: `${base}.\nAsimismo adjunto ${docs} para que nos ${devolver} y podamos formalizar la compraventa.\nQuedamos a tu disposición para cualquier duda.\nUn saludo`,
    },
  ];
}
